import { getData, postData } from "./axiosConfig"

export const getSiteInfo = async () => {
    return await getData('site/site-info')
}

export const userSubscribe = async (body) => {
    return await postData('user/create-subscription', body)
}

